import { render, staticRenderFns } from "./XToDoWizard.vue?vue&type=template&id=77c6ef0c&scoped=true&"
import script from "./XToDoWizard.vue?vue&type=script&lang=ts&"
export * from "./XToDoWizard.vue?vue&type=script&lang=ts&"
import style0 from "./XToDoWizard.vue?vue&type=style&index=0&id=77c6ef0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6ef0c",
  null
  
)

export default component.exports